export default "__VITE_ASSET__CmMtCJqB__"